import { Component, OnInit } from '@angular/core';
import { Claim, HuntApiService, Verification } from '../hunt-api.service';
import { accessMessage } from '../hunt-errors';

@Component({
  selector: 'app-hunt-finds',
  templateUrl: './hunt-finds.component.html',
  styleUrls: ['./hunt-finds.component.scss'],
})
export class HuntFindsComponent implements OnInit {
  claims: Claim[] = [];
  loading = true;
  showVoided = false;
  error = '';
  notice = '';
  code = '';
  checked: Verification | null = null;
  checkedCode = '';

  constructor(private api: HuntApiService) {}

  ngOnInit() { this.load(); }

  load() {
    this.loading = true;
    this.api.claims().subscribe(
      (r) => { this.claims = r.claims; this.loading = false; },
      (e) => { this.error = accessMessage(e); this.loading = false; },
    );
  }

  get shown() { return this.claims.filter((c) => this.showVoided || !c.voided); }
  get flagged() { return this.claims.filter((c) => c.flagged && !c.voided).length; }

  verify() {
    const code = this.code.trim().toUpperCase();
    if (!code) return;
    this.error = '';
    this.api.verify(code).subscribe(
      (r) => { this.checked = r; this.checkedCode = code; },
      (e) => (this.error = accessMessage(e)),
    );
  }

  voidClaim(c: Claim) {
    const reason = prompt(`Void ${c.code} (bone #${c.n})?\nThe bone becomes unfound again; if its slot is still running, others can find it.\n\nReason:`, c.flagged ? 'Looked automated' : '');
    if (reason === null) return;
    this.api.voidClaim(c.code, reason).subscribe(
      () => { this.notice = `${c.code} voided. Bone #${c.n} is unfound again.`; this.load(); if (this.checkedCode === c.code) this.checked = null; },
      (e) => (this.error = accessMessage(e)),
    );
  }
}
